<!--自定义列表高级筛选-->
<template>
    <el-popover
            key="searchPopover"
            ref="searchPopover"
            v-model="searchPopover"
            :width="filterPopoverWidth"
            placement="bottom-start"
            popper-class="filter_popper"
            trigger="click"
            @show="handleAdvancedFilterPopoverShow">
        <span slot="reference">
            <div class="filter_popper_btn">
                <el-button class="custom_btn" size="small"><i class="iconfont icon-shaixuan"></i></el-button>
                <template v-if="filterCount">
                    <span v-text="filterCount + '个条件'"></span>
                    <i class="iconfont icon-guanbi_dise icon-close" @click.stop="handleClickClearCondition"></i>
                </template>
            </div>
        </span>
        <div class="advanced_filter_wrap">
            <div class="filter_title_wrap">
                <span>筛选</span>
                <div>
                    <span>符合以下：</span>
                    <el-select
                            v-model="filterData.boolean"
                            class="boolean_select"
                            size="mini"
                            @change="handleAfterSendFilterData"
                    >
                        <el-option label="所有" value="and"></el-option>
                        <el-option label="任一" value="or"></el-option>
                    </el-select>
                    <el-button @click="handleClickClearCondition">清空筛选条件</el-button>
                </div>
            </div>
            <div class="filter_content_wrap">
                <ul :style="{ 'padding-right': advancedFilterList.length > 6 ? '0' : '10px' }"
                    class="advanced_filter_list">
                    <li v-for="(item, index) in advancedFilterList" class="advanced_filter_item">
                        <div class="field_select_wrap">
                            <el-select
                                    v-model="item.field_key"
                                    :disabled="item.common"
                                    class="field_select"
                                    placeholder="请选择筛选的字段"
                                    size="small"
                                    @change="handleSelectFieldKeyChange(item)">
                                <el-option
                                        v-for="field in conditionFieldList"
                                        :key="field.field_key"
                                        :label="field.field_name"
                                        :value="field.field_key">
                                </el-option>
                            </el-select>
                        </div>
                        <div class="operator_select_wrap">
                            <el-select
                                    v-if="conditionFieldList[item.field_key]"
                                    v-model="item.operator"
                                    placeholder="请选择"
                                    size="small"
                                    @change="handleAfterSendFilterData"
                            >
                                <el-option
                                        v-for="operator in conditionFieldList[item.field_key].operator_list"
                                        :key="operator.value"
                                        :label="operator.label"
                                        :value="operator.value"
                                >
                                </el-option>
                            </el-select>
                            <el-select v-else v-model="item.operator" placeholder="请选择" size="small">
                                <el-option
                                        v-for="operator in operator_list"
                                        :key="operator.value"
                                        :label="operator.label"
                                        :value="operator.value"
                                >
                                </el-option>
                            </el-select>
                        </div>
                        <div class="field_value_form_wrap">
                            <div v-if="conditionFieldList[item.field_key]">
                                <el-select
                                        v-if="conditionFieldList[item.field_key].condition_type === 'options'"
                                        v-model="item.field_value"
                                        :placeholder="'请选择' + conditionFieldList[item.field_key].field_name"
                                        collapse-tags
                                        filterable
                                        :multiple="conditionFieldList[item.field_key].hasOwnProperty('is_multiple')&&!conditionFieldList[item.field_key].is_multiple?false:true"
                                        size="small"
                                        @change="handleAfterSendFilterData"
                                        @remove-tag="handleAfterSendFilterData">
                                    <el-option
                                            v-for="option in conditionFieldList[item.field_key].options"
                                            :label="option.label"
                                            :value="option.value">
                                    </el-option>
                                </el-select>
                                <el-input-number
                                        v-else-if="conditionFieldList[item.field_key].condition_type === 'number'"
                                        v-model="item.field_value"
                                        :controls="false"
                                        :placeholder="'请输入' + conditionFieldList[item.field_key].field_name"
                                        size="small"
                                        @blur="handleAfterSendFilterData">
                                </el-input-number>
                                <div v-else-if="conditionFieldList[item.field_key].condition_type === 'date' ||
                                        conditionFieldList[item.field_key].condition_type === 'date_range'">
                                    <el-date-picker
                                            v-if="conditionFieldList[item.field_key].date_type === 'daterange'"
                                            v-model="item.field_value"
                                            :editable="false"
                                            end-placeholder="结束日期"
                                            format="yyyy/MM/dd"
                                            range-separator="～"
                                            size="small"
                                            start-placeholder="开始日期"
                                            type="daterange"
                                            value-format="yyyy-MM-dd"
                                            @change="handleAfterSendFilterData">
                                    </el-date-picker>
                                    <el-time-picker
                                            v-else-if="conditionFieldList[item.field_key].date_type === 'timerange'"
                                            v-model="item.field_value"
                                            end-placeholder="结束时间"
                                            format="HH:mm"
                                            is-range
                                            range-separator="～"
                                            size="small"
                                            start-placeholder="开始时间"
                                            value-format="HH:mm"
                                            @change="handleAfterSendFilterData">
                                    </el-time-picker>
                                    <el-date-picker
                                            v-else-if="conditionFieldList[item.field_key].date_type === 'datetimerange'"
                                            v-model="item.field_value"
                                            :editable="false"
                                            end-placeholder="结束时间"
                                            format="yyyy/MM/dd HH:mm"
                                            range-separator="～"
                                            size="small"
                                            start-placeholder="开始时间"
                                            type="datetimerange"
                                            value-format="yyyy-MM-dd HH:mm"
                                            @change="handleAfterSendFilterData"
                                            @clear="item.field_value = []">
                                    </el-date-picker>
                                    <el-date-picker
                                            v-else-if="conditionFieldList[item.field_key].date_type === 'monthrange'"
                                            v-model="item.field_value"
                                            end-placeholder="结束月份"
                                            format="yyyy/MM"
                                            range-separator="～"
                                            size="small"
                                            start-placeholder="开始月份"
                                            type="monthrange"
                                            value-format="yyyy-MM"
                                            @change="handleAfterSendFilterData">
                                    </el-date-picker>
                                </div>
                                <el-cascader
                                        v-else-if="conditionFieldList[item.field_key].condition_type === 'cascader'"
                                        v-model="item.field_value"
                                        :options="conditionFieldList[item.field_key].options"
                                        :placeholder="'请选择' + conditionFieldList[item.field_key].field_name"
                                        :props="{ value: 'value', label: 'label', children: '_child' }"
                                        size="small"
                                        @change="handleAfterSendFilterData">
                                </el-cascader>
                                <el-cascader
                                        v-else-if="conditionFieldList[item.field_key].condition_type === 'address'"
                                        v-model="item.field_value"
                                        :options="conditionFieldList[item.field_key].options"
                                        :placeholder="'请选择' + conditionFieldList[item.field_key].field_name"
                                        filterable
                                        separator="-"
                                        size="small"
                                        @change="handleAfterSendFilterData">
                                </el-cascader>
                                <el-select
                                        v-else-if="conditionFieldList[item.field_key].condition_type === 'department'"
                                        ref="depSelect"
                                        v-model="item.department_title"
                                        :multiple="item.system_type === 'system'"
                                        :placeholder="'请选择' + conditionFieldList[item.field_key].field_name"
                                        clearable
                                        collapse-tags
                                        size="small"
                                        @clear="handleClickClearDepartment(item, index)"
                                        @remove-tag="handleRemoveDepartmentTag(item, index)"
                                >
                                    <el-option :value="[]" style="height: auto; padding: 0">
                                        <el-tree
                                                :ref="`dep_select_tree${index}`"
                                                :data="departmentList"
                                                :expand-on-click-node="false"
                                                :props="{ children: 'children', label: 'relate_name' }"
                                                :show-checkbox="item.system_type === 'system'"
                                                check-on-click-node
                                                check-strictly
                                                default-expand-all
                                                highlight-current
                                                node-key="relate_id"
                                                size="mini"
                                                @check-change="
                                                (data, checked, indeterminate) =>
                                                    handleDepartmentCheckChange(data, checked, indeterminate, item)
                                            "
                                        >
                                        </el-tree>
                                    </el-option>
                                </el-select>
                                <el-select
                                        v-else-if="conditionFieldList[item.field_key].condition_type === 'contact'"
                                        v-model="item.field_value"
                                        :placeholder="'请选择' + conditionFieldList[item.field_key].field_name"
                                        :remote-method="getContactList"
                                        filterable
                                        multiple
                                        remote
                                        size="small"
                                        @change="handleAfterSendFilterData">
                                    <el-option v-for="user in contactOptions"
                                               :key="user.uid"
                                               :label="user.name"
                                               :value="user.uid">
                                    </el-option>
                                </el-select>
                                <el-select
                                        v-else-if="conditionFieldList[item.field_key].condition_type === 'checkbox_user_tag'"
                                        v-model="item.field_value"
                                        :placeholder="'请选择' + conditionFieldList[item.field_key].field_name"
                                        :remote-method="getPersonTagAllList"
                                        filterable
                                        multiple
                                        remote
                                        size="small"
                                        @change="handleAfterSendFilterData">
                                    <el-option v-for="user in personTagOptions"
                                               :key="user.id"
                                               :label="user.name"
                                               :value="user.id">
                                    </el-option>
                                </el-select>
                            </div>
                            <el-input v-else placeholder="请选择筛选的字段" size="small"></el-input>
                        </div>
                        <div class="advanced_filter_item_handle">
                            <el-checkbox
                                    v-model="item.common"
                                    :disabled="!item.field_key"
                                    @change="handleCommonCheckChange(item)"
                            >常用
                            </el-checkbox>
                            <span class="line"></span>
                            <span :class="{'handle_icon_disabled_wrap': item.common}"
                                  class="handle_icon_wrap handle_icon_danger_wrap"
                                  @click.stop="handleClickDelCondition(item, index)">
                                <i class="iconfont icon-shanchu1"></i>
                            </span>
                        </div>
                    </li>
                </ul>
            </div>
            <el-link :underline="false" type="primary" @click="handleClickAddCondition">
                <i class="el-icon-plus"></i>添加筛选条件
            </el-link>
        </div>
    </el-popover>
</template>
<script>
import {
    defaultFilterGet,
    advancedFilterAdd,
    advancedFilterDel,
    GetDepartmentList,
    GetUserList,
    PersonTagAllList,
} from "@/api";
import {getWorldArea} from "@/utils";

export default {
    name: "ListAdvancedFiltering",
    props: {
        filterPopoverWidth: {
            type: Number,
            default: () => 600,
        },
        field_list: {
            type: Array,
            default: () => [],
        },
        field_form: {
            type: String,
            default: () => "",
        },
        system_fields: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            searchPopover: false,
            filterData: {
                boolean: "and",
                custom_field: [],
                system_field: [],
                logic_field: [],
            },
            advancedFilterList: [
                {
                    field_key: "",
                    p_field_key: "",
                    field_value: undefined,
                    field_type: "",
                    common: false,
                },
            ],
            conditionFieldList: {},
            departmentList: [],
            contactOptions: [],
            personTagOptions: [],
            operator_list: [
                {label: "满足", value: "in"},
                {label: "不满足", value: "not in"},
            ],
        };
    },
    created() {

    },
    computed: {
        filterCount() {
            return (
                    this.filterData.custom_field.length +
                    this.filterData.system_field.length +
                    this.filterData.logic_field.length
            );
        },
    },
    methods: {
        handleAdvancedFilterPopoverShow() {
            if (Object.keys(this.conditionFieldList).length === 0 && this.field_list.length > 0) {
                let field_list = this.field_list.filter((field) => field.is_system === 0);
                if (this.system_fields.length) {
                    field_list = [...this.system_fields, ...field_list];
                }
                field_list.forEach((field) => {
                    const item = {
                        ...field,
                        ...field.extend,
                    };
                    item.p_field_key = "";
                    if (
                            item.field_type === "money" ||
                            item.field_type === "compute_mode" ||
                            item.field_type === "number" ||
                            item.field_type === "rate"
                    ) {
                        item.condition_type = "number";
                        item.field_value = undefined;
                        item.operator_list = [
                            {label: "大于", value: ">"},
                            {label: "大于等于", value: ">="},
                            {label: "等于", value: "="},
                            {label: "小于", value: "<"},
                            {label: "小于等于", value: "<="},
                        ];
                        this.$set(this.conditionFieldList, item.field_key, item);
                    } else if (item.field_type === "order_amount_compute_mode") {
                        if (item.status === 0) {
                            item.condition_type = "number";
                            item.field_value = undefined;
                            item.operator_list = [
                                {label: "大于", value: ">"},
                                {label: "大于等于", value: ">="},
                                {label: "等于", value: "="},
                                {label: "小于", value: "<"},
                                {label: "小于等于", value: "<="},
                            ];
                            this.$set(this.conditionFieldList, item.field_key, item);
                        }
                    } else if (item.field_type === "date") {
                        if (item.date_type === "year-month") {
                            item.date_type = "monthrange";
                        } else {
                            item.date_type = item.date_type + "range";
                        }
                        item.condition_type = "date";
                        item.field_value = [];
                        if (item.date_type === "timerange") {
                            item.field_value = [new Date(2025, 1, 1, 9, 0), new Date(2025, 1, 1, 18, 0)];
                        }
                        item.operator_list = [
                            {label: "满足", value: "between"},
                            {label: "不满足", value: "not between"},
                        ];
                        this.$set(this.conditionFieldList, item.field_key, item);
                    } else if (item.field_type === "date_range") {
                        item.condition_type = "date";
                        item.field_value = [];
                        item.operator_list = [
                            {label: "满足", value: "between"},
                            {label: "不满足", value: "not between"},
                        ];
                        this.$set(this.conditionFieldList, item.field_key, item);
                    } else if (item.field_type === "radio" || item.field_type === "checkbox") {
                        item.condition_type = "options";
                        item.field_value = item.hasOwnProperty('is_multiple') && !item.is_multiple ? '' : [];
                        if (item.system_type === "system") {
                            item.operator_list = [
                                {label: "满足", value: "="},
                                {label: "不满足", value: "!="},
                            ];
                        } else {
                            item.operator_list = [
                                {label: "满足", value: "in"},
                                {label: "不满足", value: "not in"},
                            ];
                        }
                        this.$set(this.conditionFieldList, item.field_key, item);
                    } else if (item.field_type === "checkbox_user_tag") {
                        item.condition_type = "checkbox_user_tag";
                        item.field_value = [];
                        item.operator_list = [
                            {label: "满足", value: "in"},
                            {label: "不满足", value: "not in"},
                        ];
                        item.options = [];
                        this.$set(this.conditionFieldList, item.field_key, item);
                    } else if (item.field_type === "cascader") {
                        item.condition_type = "cascader";
                        item.field_value = [];
                        item.operator_list = [
                            {label: "满足", value: "in"},
                            {label: "不满足", value: "not in"},
                        ];
                        this.$set(this.conditionFieldList, item.field_key, item);
                    } else if (item.field_type === "department") {
                        item.condition_type = "department";
                        if (item.system_type === "system") {
                            item.field_value = [];
                            item.department_title = [];
                        } else {
                            item.field_value = "";
                            item.department_title = "";
                        }
                        item.operator_list = [
                            {label: "满足", value: "in"},
                            {label: "不满足", value: "not in"},
                        ];
                        this.$set(this.conditionFieldList, item.field_key, item);
                    } else if (item.field_type === "contact") {
                        item.field_value = [];
                        item.condition_type = "contact";
                        item.operator_list = [
                            {label: "满足", value: "in"},
                            {label: "不满足", value: "not in"},
                        ];
                        this.$set(this.conditionFieldList, item.field_key, item);
                    } else if (item.field_type === "address") {
                        item.field_value = [];
                        item.condition_type = "address";
                        item.options = getWorldArea(item.area_accuracy);
                        item.operator_list = [
                            {label: "满足", value: "in"},
                            {label: "不满足", value: "not in"},
                        ];
                        this.$set(this.conditionFieldList, item.field_key, item);
                    } else if (item.field_type === "table") {
                        item._child.forEach((child_obj) => {
                            const child = {
                                ...child_obj,
                                ...child_obj.extend,
                            };
                            child.field_name = item.field_name + "." + child.field_name;
                            child.p_field_type = item.field_type;
                            if (
                                    child.field_type === "number" ||
                                    child.field_type === "money" ||
                                    child.field_type === "compute_mode" ||
                                    child.field_type === "rate"
                            ) {
                                child.condition_type = "number";
                                child.field_value = undefined;
                                child.operator_list = [
                                    {label: "大于", value: ">"},
                                    {label: "大于等于", value: ">="},
                                    {label: "等于", value: "="},
                                    {label: "小于", value: "<"},
                                    {label: "小于等于", value: "<="},
                                ];
                                this.$set(this.conditionFieldList, child.field_key, child);
                            } else if (child.field_type === "date") {
                                child.condition_type = "date";
                                child.field_value = "";
                                child.operator_list = [
                                    {label: "满足", value: "between"},
                                    {label: "不满足", value: "not between"},
                                ];
                                this.$set(this.conditionFieldList, child.field_key, child);
                            } else if (child.field_type === "date_range") {
                                child.date_type = "date";
                                child.condition_type = "date";
                                child.field_value = [];
                                child.operator_list = [
                                    {label: "满足", value: "between"},
                                    {label: "不满足", value: "not between"},
                                ];
                                this.$set(this.conditionFieldList, child.field_key, child);
                            } else if (child.field_type === "radio" || child.field_type === "checkbox") {
                                child.condition_type = "options";
                                child.field_value = [];
                                child.operator_list = [
                                    {label: "满足", value: "in"},
                                    {label: "不满足", value: "not in"},
                                ];
                                this.$set(this.conditionFieldList, child.field_key, child);
                            } else if (child.field_type === "department") {
                                child.condition_type = "department";
                                if (child.system_type === "system") {
                                    child.field_value = [];
                                    child.department_title = [];
                                } else {
                                    child.field_value = "";
                                    child.department_title = "";
                                }
                                child.operator_list = [
                                    {label: "满足", value: "in"},
                                    {label: "不满足", value: "not in"},
                                ];
                                this.$set(this.conditionFieldList, child.field_key, child);
                            } else if (child.field_type === "contact") {
                                child.condition_type = "contact";
                                child.field_value = [];
                                child.operator_list = [
                                    {label: "满足", value: "in"},
                                    {label: "不满足", value: "not in"},
                                ];
                                this.$set(this.conditionFieldList, child.field_key, child);
                            } else if (child.field_type === "address") {
                                child.condition_type = "address";
                                child.field_value = [];
                                child.operator_list = [
                                    {label: "满足", value: "in"},
                                    {label: "不满足", value: "not in"},
                                ];
                                child.options = getWorldArea(child.area_accuracy);
                                this.$set(this.conditionFieldList, child.field_key, child);
                            }
                        });
                    }
                });
                defaultFilterGet({
                    field_form: this.field_form,
                }).then((res) => {
                    if (res.code === 200) {
                        if (res.data.length) {
                            res.data.forEach((item) => {
                                if (this.conditionFieldList.hasOwnProperty(item)) {
                                    this.advancedFilterList.unshift({
                                        field_key: this.conditionFieldList[item].field_key,
                                        p_field_key: this.conditionFieldList[item].p_field_key,
                                        field_value: this.conditionFieldList[item].field_value,
                                        operator: this.conditionFieldList[item].operator_list[0].value,
                                        field_type: this.conditionFieldList[item].field_type,
                                        common: true,
                                    });
                                }
                            });
                        }
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
        },

        getContactList(keyword) {
            GetUserList({keyword}).then((res) => {
                if (res.code === 200) {
                    this.contactOptions = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        getDepartmentList() {
            GetDepartmentList().then((res) => {
                if (res.code === 200) {
                    this.departmentList = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        //获取人员标签列表
        getPersonTagAllList(keyword) {
            PersonTagAllList({
                keyword,
            }).then((res) => {
                if (res.code === 200) {
                    this.personTagOptions = res.data || [];
                } else {
                    this.$message.error(res.message);
                }
            });
        },

        //点击添加条件
        handleClickAddCondition() {
            this.advancedFilterList.push({
                field_key: "",
                p_field_key: "",
                field_value: undefined,
                field_type: "",
                operator: "",
                common: false,
            });
        },

        //删除筛选条件
        handleClickDelCondition(item, index) {
            if (item.common) return false;
            this.advancedFilterList.splice(index, 1);
            this.handleAfterSendFilterData();
        },

        //清空筛选条件
        handleClickClearCondition() {
            if (this.advancedFilterList.some((item) => item.common)) {
                this.advancedFilterList = this.advancedFilterList.filter((item) => item.common);
                this.advancedFilterList.forEach((item) => {
                    item.operator = "";
                    item.field_value = undefined;
                });
            } else {
                // 产品提的清空筛选不需要默认有一条筛选数据
                // this.advancedFilterList = [
                //     {
                //         field_key: "",
                //         p_field_key: "",
                //         field_value: undefined,
                //         field_type: "",
                //         operator: "",
                //         common: false,
                //     },
                // ];
                this.advancedFilterList = []
            }
            this.handleAfterSendFilterData();
        },

        //选择筛选字段事件
        handleSelectFieldKeyChange(item) {
            const field = this.conditionFieldList[item.field_key];
            item.p_field_key = field.p_field_key;
            item.field_type = field.p_field_key ? field.p_field_type : field.field_type;
            item.field_value = field.field_value;
            item.operator = field.operator_list[0].value;
            if (field.system_type) {
                item.system_type = field.system_type;
            }
            if (field.field_type === "department") {
                item.department_title = field.department_title;
                if (this.departmentList.length === 0) {
                    this.getDepartmentList();
                }
            } else if (field.field_type === "contact") {
                if (this.contactOptions.length === 0) {
                    this.getContactList();
                }
            } else if (field.field_type === "checkbox_user_tag") {
                if (this.personTagOptions.length === 0) {
                    this.getPersonTagAllList();
                }
            }
        },

        //切换常用事件
        handleCommonCheckChange(item) {
            if (item.common) {
                advancedFilterAdd({
                    field_form: this.field_form,
                    field_key: item.field_key,
                }).then((res) => {
                    if (res.code === 200) {
                        this.$message.success("设置成功");
                    } else {
                        this.$message.error(res.message);
                    }
                });
            } else {
                advancedFilterDel({
                    field_form: this.field_form,
                    field_key: item.field_key,
                }).then((res) => {
                    if (res.code === 200) {
                        this.$message.success("设置成功");
                    } else {
                        this.$message.error(res.message);
                    }
                });
            }
        },

        //选择部门事件
        handleDepartmentCheckChange(data, checked, indeterminate, item) {
            if (item.system_type === "system") {
                if (checked) {
                    item.department_title.push(data.relate_name);
                    item.field_value.push(data.relate_id);
                } else {
                    item.department_title = item.department_title.filter((item) => item !== data.relate_name);
                    item.field_value = item.field_value.filter((item) => item !== data.relate_id);
                }
            } else {
                this.$set(item, "field_value", data.relate_id);
                this.$set(item, "department_title", data.relate_name);
                this.$refs.depSelect[0].blur();
            }
            this.handleAfterSendFilterData();
        },

        //清除部门选择
        handleClickClearDepartment(item, index) {
            if (item.system_type === "system") {
                item.field_value = [];
                item.department_title = [];
                this.$refs[`dep_select_tree${index}`][0].setCheckedKeys([]);
            } else {
                item.field_value = "";
                item.department_title = "";
            }
            this.handleAfterSendFilterData();
        },

        //移除多选部门的标签
        handleRemoveDepartmentTag(item, index) {
            item.field_value.shift();
            const keys = item.field_value.map((item) => item);
            item.field_value = [];
            item.department_title = [];
            this.$refs[`dep_select_tree${index}`][0].setCheckedKeys([]);
            this.$nextTick(() => {
                this.$refs[`dep_select_tree${index}`][0].setCheckedKeys(keys);
            });
            this.handleAfterSendFilterData();
        },

        //字段值操作完成后将筛选数据传递给父组件
        handleAfterSendFilterData() {
            this.filterData.custom_field = [];
            this.filterData.system_field = [];
            this.filterData.logic_field = [];
            this.advancedFilterList.forEach((item) => {
                if (
                        (Array.isArray(item.field_value) && item.field_value.length) ||
                        (!Array.isArray(item.field_value) && item.field_value !== undefined)
                ) {
                    if (item.field_type === "address") {
                        item.field_value = item.field_value[item.field_value.length - 1];
                    }
                    if (item.p_field_key) {
                        if (item.system_type) {
                            if (item.system_type === "system") {
                                this.filterData.system_field.push({
                                    operator: item.operator,
                                    field_key: [item.p_field_key, item.field_key],
                                    field_value: item.field_value,
                                    field_type: item.field_type,
                                });
                            } else {
                                this.filterData.logic_field.push({
                                    operator: item.operator,
                                    field_key: [item.p_field_key, item.field_key],
                                    field_value: item.field_value,
                                    field_type: item.field_type,
                                });
                            }
                        } else {
                            this.filterData.custom_field.push({
                                operator: item.operator,
                                field_key: [item.p_field_key, item.field_key],
                                field_value: item.field_value,
                                field_type: item.field_type,
                            });
                        }
                    } else {
                        if (item.system_type) {
                            if (item.system_type === "system") {
                                this.filterData.system_field.push({
                                    operator: item.operator,
                                    field_key: item.field_key,
                                    field_value: item.field_value,
                                    field_type: item.field_type === 'checkbox_user_tag' ? 'radio' : item.field_type,
                                });
                            } else {
                                this.filterData.logic_field.push({
                                    operator: item.operator,
                                    field_key: item.field_key,
                                    field_value: item.field_value,
                                    field_type: item.field_type,
                                });
                            }
                        } else {
                            this.filterData.custom_field.push({
                                operator: item.operator,
                                field_key: item.field_key,
                                field_value: item.field_value,
                                field_type: item.field_type,
                            });
                        }
                    }
                }
            });
            this.$emit("sendFilterData", this.filterData);
        },
    },
};
</script>
<style lang="scss">
.filter_popper_btn {
    border: 1px solid $btn-border-color;
    padding: 0 8px;
    height: 32px;
    border-radius: 4px;
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;

    .iconfont {
        color: rgba(102, 102, 102, 1);
        vertical-align: middle;
    }

    .icon-close {
        color: rgba(191, 191, 191, 1);
        vertical-align: middle;

        &:hover {
            color: #999999;
        }
    }

    .el-button {
        font-size: 16px;
        border: none;
        padding: 0;
    }

    &:hover,
    &:focus {
        background-color: transparent;
        border-color: $btn-border-hover-color;
        color: $btn-border-hover-color;

        .icon-shaixuan {
            color: $btn-border-hover-color;
        }
    }

    &:active {
        background-color: transparent;
        border-color: $btn-border-active-color;
        color: $btn-border-active-color;

        .icon-shaixuan {
            color: $btn-border-active-color;
        }

        .icon-close {
            color: rgba(173, 173, 173, 1);
        }
    }
}

.advanced_filter_wrap {
    .filter_title_wrap {
        display: flex;
        align-items: center;
        height: 24px;
        line-height: 24px;
        justify-content: space-between;
        margin-bottom: 16px;

        & > span {
            font-size: 16px;
            font-weight: 700;
            letter-spacing: 0px;
            line-height: 24px;
            color: $font-active-color;
        }

        & > div {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            height: 24px;
            line-height: 24px;
            color: $font-base-color;
            display: flex;
            align-items: center;

            .el-button {
                width: 91px;
                height: 24px;
                text-align: center;
                line-height: 24px;
                padding: 0;
                opacity: 1;
                border-radius: 4px;
                background: rgba(255, 255, 255, 1);
                border: 1px solid $btn-border-color;
                color: $font-active-color;
                font-size: 12px;
                font-weight: 400;

                &:hover {
                    border-color: rgba(75, 162, 255, 1);
                    color: rgba(75, 162, 255, 1);
                }

                &:active {
                    border-color: $btn-border-active-color;
                    color: $btn-border-active-color;
                }

                &.is-disabled {
                    background: rgba(247, 247, 247, 1) !important;
                    border-color: rgba(217, 217, 217, 1) !important;
                    color: rgba(191, 191, 191, 1) !important;
                }
            }
        }
    }

    .filter_content_wrap {
        width: calc(100% + 10px);
        max-height: 300px;
        overflow-y: auto;

        .advanced_filter_list {
            .advanced_filter_item {
                display: flex;
                align-items: center;
                gap: 8px;
                margin-bottom: 12px;

                .field_select_wrap {
                    width: 184px;
                }

                .operator_select_wrap {
                    width: 86px;

                    .el-input__inner {
                        padding: 0 12px;
                    }
                }

                .field_value_form_wrap {
                    width: 214px;

                    .el-input-number {
                        width: 100%;

                        .el-input__inner {
                            text-align: left;
                        }
                    }

                    .el-date-editor--daterange.el-input__inner {
                        width: 100%;
                    }

                    .el-date-editor--timerange.el-input__inner {
                        width: 100%;
                    }

                    .el-date-editor .el-range-separator {
                        padding: 0;
                    }

                    .el-date-editor--time .el-input__inner {
                        padding: 0 12px 0 26px;
                    }

                    .el-select {
                        width: 100%;
                    }

                    .el-cascader {
                        width: 100%;
                    }
                }

                .advanced_filter_item_handle {
                    line-height: 22px;
                    display: flex;
                    align-items: center;

                    .el-checkbox {
                        .el-checkbox__inner {
                            border-color: $btn-border-color;
                            border-radius: 4px;
                            width: 16px;
                            height: 16px;

                            &::after {
                                left: 5px;
                                top: 2px;
                            }
                        }

                        .el-checkbox__label {
                            line-height: 22px;
                            font-size: 14px;
                            font-weight: 400;
                            letter-spacing: 0px;
                            color: $font-base-color;
                            padding-left: 8px;
                        }

                        &:hover {
                            .el-checkbox__inner {
                                border-color: #4BA2FF;
                            }
                        }

                        &.is-disabled {
                            &:hover {
                                .el-checkbox__inner {
                                    border-color: #d9d9d9 !important;
                                }
                            }
                        }

                        &.is-checked {
                            .el-checkbox__inner {
                                border-color: rgba(41, 144, 255, 1);
                                background-color: rgba(41, 144, 255, 1);
                            }
                        }
                    }

                    .icon-shanchu1 {

                        &.delete_disable {
                            color: #bfbfbf !important;
                            pointer-events: none !important;
                        }
                    }
                }
            }
        }
    }
}

.filter_popper {
    border-radius: 8px;
    background: #ffffff;
    border: 1px solid #e8e8e8;
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.08);
    padding: 16px;
}
</style>
